import { Component, OnInit, ViewChild }              from '@angular/core';
import { Inject}                                     from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA}   from '@angular/material';
import { MatSnackBar }                               from '@angular/material';

import { TdDialogService }                           from '@covalent/core';
import { ViewContainerRef }                          from '@angular/core';

import {FormControl}                                 from '@angular/forms';
import {Observable}                                  from 'rxjs';

import { AppService }                                from '../../../../../core/service/app.service';

import { License }                                   from '../../../vo/license';
import { LicenseService }                            from '../../../service/license.service';

/**
 * License Popup Unsuscribe Kylii Program
 * 
 * This component is used to ask if we need to sync information now or not
 */
@Component(
{
    selector: 'license-popup-unsuscribe-kylii-program-component',
    templateUrl: 'license.popup.unsuscribe.kylii.program.component.html',
    styleUrls: [ 'license.popup.unsuscribe.kylii.program.component.css']
})
export class LicensePopupUnsuscribeKyliiProgramComponent implements OnInit
{
    /**
     * Constructor
     * 
     */
	constructor
	(
		private dialogRef: MatDialogRef<LicensePopupUnsuscribeKyliiProgramComponent>,
        private _dialogService: TdDialogService,
        private licenseService:LicenseService,
        private _viewContainerRef: ViewContainerRef,
        private snackBar: MatSnackBar,
        /**
        * Access to the Main App Service
        */
        public appService: AppService, 
        private dialog: MatDialog,
        /**
        * Datas pass to the component
        */
		@Inject(MAT_DIALOG_DATA) public data: any
	) 
    {
    }

    /**
    * Index for the Loading component
    */
    public index_loading:number;


    /*****************************************************************/
    //
    // Initialisation
    //
    /*****************************************************************/

    /**
     * Initialisation
     * 
     */
    ngOnInit(): void 
    {
       
    }


    /*****************************************************************/
    //
    // Dialog
    //
    /*****************************************************************/

    /**
     * Open an alert message
     * 
     * @param {string} Content of the message
     * @param {string} Title of the message
     * @param {string} Label of the close button
     */
    public openDialog( content:string, title:string, closeButton:string )
    {
        this._dialogService.openAlert
        (
            {
                message: content,
                title: title, 
                closeButton: closeButton, 
            }
        );
    }


    /*****************************************************************/
    //
    // Popup
    //
    /*****************************************************************/

    /**
    * Called when the user clik outside the popup
    *
    */
    onNoClick(): void 
    {
        this.dialogRef.close();
    }

    /**
    * Close the popup
    *
    */
    public on_close():void
    {
        this.dialogRef.close();
    }
}

